import {useSelector} from 'react-redux';
import {routeSelector} from '@app/router/redux';
import {Label} from '@app/components/elements/Label';
import {useStyles} from './styles';

export const ZhoTransferNavbar = () => {
  const classes = useStyles();
  const navbarComponentHeading = useSelector(
    routeSelector.getNavbarComponentHeading(),
  );

  return (
    <div className={classes.container}>
      <div className={classes.flexSpaceBetween}>
        <Label
          title={navbarComponentHeading}
          variant="h6"
          testID={'superman_admin_navbar_heading'}
          textColor={'#322b7c'}
          fontWeight={'800'}
          hideToolTip
        />
      </div>
    </div>
  );
};
